// A helper function that finds one image object in an array of Cloudinary image objects
// To use it, pass an object that has two properties: fileName and imagesArray
// Where fileName is the file name of the image you want to find, and imagesArray is the array of Cloudinary images you are searching through.
export default function findCloudinaryImage({ fileName, images }) {
  // Check if fileName is provided
  if (!fileName) {
    throw new Error('findCloudinaryImage: fileName is required.');
  }

  // Check if images array is provided
  if (!images) {
    throw new Error('findCloudinaryImage: image array is required.');
  }

  // Loop through the images array and find the matching object based on the fileName
  const foundImage = images.find(imageObj => {
    // Extract the src from the object to check for the fileName
    let src =
      imageObj?.node?.childCloudinaryAsset?.gatsbyImageData?.images?.fallback
        ?.src;

    if (!src) return false;

    // Add Cloudinary transformation parameters to optimize the image and convert to WebP format
    src += '?f=webp'; // Now includes format conversion to WebP

    return src.includes(fileName);
  });

  // Throw an error if the fileName is not found and log the images array
  if (!foundImage) {
    throw new Error(
      `findCloudinaryImage: The fileName '${fileName}' was not found in the images array provided. The function returned ${foundImage}.`
    );
  }

  return foundImage.node.childCloudinaryAsset;
}
